import axios from "axios";
import { getToken } from "../session";

const PATCH = async (endpoint, data) => {
  const response = await axios.patch(endpoint, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  });
  return response;
};

export default PATCH;
